<template>
    <div class="px-4">
        <div class="box-point-account bg-white max-w-lg m-auto rounded-10 p-4 relative">
            <img class="w-30px m-auto mb-3" src="../../../../../../assets/password/unlock.svg">
            <div class="text-a-brown-9f8273 font-bold text-center"><HelloMessage></HelloMessage> <span class="text-a-brown-502314">Guest</span></div>
            <div class="text-a-red-d62300 text-14 text-center mt-1">{{lbl.profile.register_to_privilege}}</div>
            <div class="absolute top-3 right-3">
                <router-link to="/point">
                    <img class="w-18px" src="../../../../../../assets/icon/info.svg">
                </router-link>
            </div>
        </div>
    </div>
</template>
<script>
import HelloMessage from '@/components/Layout/Page/HomeLayout/HelloMessage.vue';
// mixins
import LocaleMixin from '@/mixin/LocaleMixin';
export default {
    mixins:[LocaleMixin],
    components: {
        HelloMessage
    }

}
</script>
<style lang="scss" scoped>
    .box-point-account {
        background-image: url('../../../../../../assets/bg/BG-card@3x.png');
        background-repeat: no-repeat;
        background-size: cover;
        background-position-x: center;
        background-position-y: center;
    }
</style>
